import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "../../../environments/environment";
import { Email, EmailForm, Page } from '../models';

@Injectable()
export class EmailService {

    emailsUrl = environment.dns + 'api/emails/';

    constructor(private http: HttpClient) { }

    getPaginate(societyId: number, page: number, size: number): Observable<Page<Email>> {
        return this.http.get<Page<Email>>(this.emailsUrl + 'paginate-by-society?societyId=' + societyId + '&page=' + page + '&size=' + size);
    }

    getOne(id: number): Observable<Email> {
        return this.http.get<Email>(this.emailsUrl + id);
    }

    add(emailForm: EmailForm): Observable<Email> {
        return this.http.post<Email>(this.emailsUrl, emailForm);
    }

    update(emailForm: EmailForm): Observable<Email> {
        return this.http.put<Email>(this.emailsUrl, emailForm);
    }

    delete(id: number): Observable<boolean> {
        return this.http.delete<boolean>(this.emailsUrl + id);
    }
}